<div class="field col-12 md:col-6">
  <p class="header-item">{{bindingModuleName|translate}}</p>
</div>
<div class="center">
  <p class="center">ผลการคัดกรองนักเรียน
  </p>
  <p class="center">
    ประจำปีการศึกษา {{bindingTermName}}
    </p>
</div>
<div class="customCard dataGrid" >
  <table>
    <tr>
      <th rowspan="2" colspan="3">ห้อง</th>
       <th colspan="3">ด้านที่ 1</th>
       <th colspan="3">ด้านที่ 2</th>
       <th colspan="3">ด้านที่ 3</th>
       <th colspan="3">ด้านที่ 4</th>
       <th colspan="3">ด้านที่ 5</th>
       <th colspan="3">ด้านที่ 6</th>
       <th colspan="3">ด้านที่ 7</th>
       <th colspan="3">ด้านที่ 8</th>
       <th colspan="3">ด้านที่ 9</th>
       <th colspan="3">ด้านที่ 10</th>
    </tr>
    <tr>
      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>

      <th>ป</th>
      <th>ส</th>
      <th>ห</th>
   </tr>
    <tr *ngFor="let en of bindingDataSource">
       <td colspan="3">{{en['name1']}}</td>
       <td >{{en['value1']}}</td>
       <td >{{en['value2']}}</td>
       <td >{{en['value3']}}</td>

       <td >{{en['value4']}}</td>
       <td >{{en['value5']}}</td>
       <td >{{en['value6']}}</td>

       <td >{{en['value7']}}</td>
       <td >{{en['value8']}}</td>
       <td >{{en['value9']}}</td>

       <td >{{en['value10']}}</td>
       <td >{{en['value11']}}</td>
       <td >{{en['value12']}}</td>

       <td >{{en['value13']}}</td>
       <td >{{en['value14']}}</td>
       <td >{{en['value15']}}</td>

       <td >{{en['value16']}}</td>
       <td >{{en['value17']}}</td>
       <td >{{en['value18']}}</td>

       <td >{{en['value19']}}</td>
       <td >{{en['value20']}}</td>
       <td >{{en['value21']}}</td>

       <td >{{en['value22']}}</td>
       <td >{{en['value23']}}</td>
       <td >{{en['value24']}}</td>

       <td >{{en['value25']}}</td>
       <td >{{en['value26']}}</td>
       <td >{{en['value27']}}</td>

       <td >{{en['value28']}}</td>
       <td >{{en['value29']}}</td>
       <td >{{en['value30']}}</td>

    </tr>

 </table>
</div>

